import _ from 'underscore';

import warningMessageTemplate from './warning-message-bullets-temp.pug';
import { createViewClass } from './section-factory';

export function createUpdateEntityView({
  subSectionsConfig,
  sectionLabel,
  model,
  i18n,
  hideAdvancedOptions,
  helpId = 'Pop_BA_Import_UpdateExistingItems',
}) {
  const updateEntityControlParameters = {
    subSectionsConfig,
    sectionLabel,
    model,
    i18n,
    hideAdvancedOptions,
    description: i18n.get('Import_ImportOptions_ImportExisting_AdvancedSub'),
    helpId,
  };
  const warningMessage = warningMessageTemplate({
    warningText: i18n.get('Import_ImportOptions_UpdateEntityUncheckedWarning'),
    bulletTexts: _.compact([
      i18n.get('ImportUpdateEntityPreference_UpdateCampaignBudget_BidSection'),
      i18n.get('ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids_Bids'),
      i18n.get('ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids_BidStrategies'),
    ]),
  });

  _.extend(updateEntityControlParameters, {
    warningMessage,
  });
  return createViewClass(updateEntityControlParameters);
}
